import { MessagePartType, type ToolCallSummary } from '@/features/types/tools';
import { ChatMarkDownFormatter } from './ChatMarkDownFormatter';
import { ToolCallRenderer } from './toolCalls/ToolCallRenderer';

interface ChatAiFormatterProps {
  content: Array<string | ToolCallSummary>;
}

export function ChatAiFormatter({ content }: ChatAiFormatterProps) {
  return (
    <div className="space-y-2">
      {content.map((part, index) => {
        if (typeof part === 'string') {
          return <ChatMarkDownFormatter key={index} content={part} />;
        } else if (part.type === MessagePartType.ToolCall) {
          return <ToolCallRenderer key={index} toolCall={part} />;
        }

        return null;
      })}
    </div>
  );
}
